export default __webpack_public_path__ + "static/media/prenatalLandingPageTestimonial3.a5dcb24e.png";